<template>
  <div class="columns"> <!--Início das colunas principais-->

    <div class="column is-two-fifths" id="menu"><!-- Início coluna de menu esquerdo-->
      <div class="logo">
        <img src="../assets/nosconectados.svg" width="200" height="130">
        <h2 class="is-size-4 is-uppercase has-text-weight-light">Bem vindo, {{ user.firstName }}</h2>
      </div>

      <div class="info-sensor" v-if="sensorData">
        <b-field label="Propriedade" class="mt-5" grouped label-position="on-border">
          <b-select placeholder="Identificação da propriedade" expanded v-model="property">
            <option v-for="sensor in sensorData.dados" :key="sensor.id">
              {{ sensor.property }}
            </option>
          </b-select>
          <p class="control" v-if="property">
            <b-button class="button is-primary" @click="clearFilter">Limpar</b-button>
          </p>
        </b-field>
        <InfoSensor :isResumoActive="isResumoActive" :isAreaActive="isAreaActive" :isProducaoActive="isProducaoActive"
          :isLocalizacaoActive="isLocalizacaoActive" :filteredItems="filteredItems" @updateMap="updateMap" />
      </div>
      <div v-else class="imagem">
        <img src="../assets/sensor-null.svg" />
        <h1 class="is-size-5 center is-uppercase has-text-weight-light">Nenhum sensor identificado!</h1>
      </div>
      <footer>
        <div class="buttons ml-2">
          <b-button size="is-large" v-on:click="setActiveSection('resumo')">
            <b-icon icon="bell-plus" size="is-large" class="mr-1"></b-icon>
            Resumo
          </b-button>
          <b-button size="is-large" v-on:click="setActiveSection('area')">
            <b-icon icon="apps" size="is-large" class="mr-1"></b-icon>
            Áreas
          </b-button>
          <b-button size="is-large" v-on:click="setActiveSection('producao')">
            <b-icon icon="sprout" size="is-large" class="mr-1"></b-icon>
            Produção
          </b-button>
          <b-button size="is-large" v-on:click="setActiveSection('localizacao')">
            <b-icon icon="map-marker-outline" size="is-large" class="mr-1"></b-icon>
            Localização
          </b-button>
        </div>
      </footer>
    </div><!-- Fim column de menu esquerdo-->

    <div class="column"><!--Início coluna direita mapa-->
      <template id="mapa">
        <l-map ref="myMap" :zoom="zoom" :center="center">
          <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
          <l-marker :lat-lng="markerLatLng">
            <l-icon :icon-size="iconSize" :icon-anchor="iconAnchor" :icon-url="iconUrl">
            </l-icon>
          </l-marker>
          <l-circle :lat-lng="circle.center" :radius="circle.radius" :color="circle.color">
          </l-circle>
        </l-map>
      </template>
    </div><!-- Fim column direita mapa-->
  </div><!-- Fim columns principais -->
</template>

<script>
import { mapState } from "vuex";
import { LMap, LTileLayer, LMarker, LCircle, LIcon } from 'vue2-leaflet';
import { getSensorFromUser } from "../services/api";
import InfoSensor from '@/components/InfoDashboard.vue';

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LCircle,
    LIcon,
    InfoSensor,
  },
  data() {
    return {
      tam: 0,
      sensorData: [],
      isSwitchedCustom: 'Light',
      iconUrl: 'https://icon-library.com/images/map-png-icon/map-png-icon-17.jpg',
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
        '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      zoom: 14,
      center: [-31.78095019, -52.32305668],
      markerLatLng: [0, 0],
      circle: {
        center: [0, 0],
        radius: 0,
        color: '#40a5f5'
      },
      iconSize: [45, 45],
      iconAnchor: [37, 37],
      options: {
        enableHighAccuracy: true,
        timeout: 50000,
        maximumAge: 0,
      },
      property: null,
      activeSection: 'resumo',
    };
  },
  computed: {
    ...mapState(["user"]),
    isResumoActive() {
      return this.activeSection === 'resumo';
    },
    isAreaActive() {
      return this.activeSection === 'area';
    },
    isProducaoActive() {
      return this.activeSection === 'producao';
    },
    isLocalizacaoActive() {
      return this.activeSection === 'localizacao';
    },
    filteredItems() {
      if (this.sensorData === null) {
        return null;
      }
      let filterSensors = [];
      if (typeof this.sensorData.dados === 'object' && this.sensorData !== null) { 
        const dataKeys = Object.keys(this.sensorData.dados);
        filterSensors = dataKeys.filter((key) => {
          const filterSensor = this.sensorData.dados[key];
          if (this.property == null) return filterSensor;
          return filterSensor.property === this.property;
        }).map(key => this.sensorData.dados[key]);
      }
      return filterSensors;
    },
  },
  mounted() {
    this.loadSensor();
    this.getLocation();
  },
  methods: {
    loadSensor() {
      return getSensorFromUser()
        .then((res) => {
          this.sensorData = res.data;
          this.dataMap(this.sensorData);
          if (this.sensorData.dados.length > 0) {
            const sensorArea = parseFloat(this.sensorData.dados[0].area);
            this.circle.radius = 10000*(Math.sqrt(sensorArea / Math.PI));
          }
        })
        .catch(() => {
          this.error = true;
        });
    },
    setActiveSection(section) {
      this.activeSection = section;
    },
    clearFilter() {
      this.property = null;
    },
    dataMap(data) {
      return data
    },
    updateMap(id) {
      var data = this.dataMap(this.sensorData.dados);
      var tam = Object.keys(data).length;
      for (var i = 0; i < tam; i++) {
        if (data[i] === undefined) {
          i++;
        }
        if (id === data[i].id) {
          var lat = data[i].latitude;
          var lon = data[i].longitude;
        }
      }
      this.iconUrl = 'https://cdn-icons-png.flaticon.com/512/6650/6650928.png';
      this.center = [lat, lon];
      this.markerLatLng = [lat, lon];
      this.zoom = 30;
      //const desvio = 0.000300;
      this.circle.center = [lat, lon];
    },
    getLocation() {
      navigator.geolocation.getCurrentPosition(this.success, this.error, this.options);
    },
    success(pos) {
      const crd = pos.coords;
      this.center = [crd.latitude, crd.longitude];
      this.markerLatLng = [crd.latitude, crd.longitude];
      this.zoom = 30;
    },
    error(err) {
      console.warn(`ERROR(${err.code}): ${err.message}`);
    },


  },
}
</script>


<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Staatliches&display=swap");

.box {
  height: 100vh;
  width: auto;
}

.logo {
  margin-left: auto;
  margin-right: auto;
  margin-top: 20px;
  text-align: center;
}

footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  top: 1;
}

.imagem {
  width: 400px;
  height: 400px;
  margin-top: 80px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: auto;
}

.buttons {
  margin-top: -70px;
}

#mapa {
  height: 100vh;
  position: relative;
}

#Dark .letra {
  color: #ffffff;
}

#Dark #menu {
  background-color: #000000;
  color: #ffffff;
}

#menu {
  height: 100vh;
}

.center-table {
  margin-top: auto;
  margin-left: auto;
  margin-bottom: auto;
  margin-right: auto;
}

.mode {
  position: absolute;
  color: #000000;
}
</style>